/************  GESTION DES BLOCS *****************/

    $(window).load(setupBlocks);

    function setupBlocks() {
        initBlockMedia();
        initBlockTabs();
        initSwiperSlider();
        initFaqBlock();
        initBlockQualif();
        initBlockMissions()
        initBlockRegions();
        initBlockCertifs();
        initPodcasts();
        initBookGallery();
    }

    // Fonction qui permet de lire une vidéo
    function initBlockMedia() {
        $('.blocktextimg-media.has-video, .blockmedia-media.has-video').click(function() {
            if(!$(this).hasClass('showVideo'))  {
                $(this).addClass('showVideo');
                // Lecture des vidéos Youtube et Vimeo
                if($(this).find("iframe").length !== 0) {
                    let videoUrl = $(this).find("iframe").attr('src');
                    $(this).find(".video_player iframe").attr('allow', 'autoplay; fullscreen');
                    if(videoUrl.split('?').length > 0) videoUrl = videoUrl.split('?')[0]
                    $(this).find(".youtube_player iframe").attr('src', videoUrl + '?theme=light&rel=0&controls=1&enablejsapi=1&showinfo=0&autoplay=1');
                    $(this).find(".vimeo_player iframe").attr('src', videoUrl + '?autoplay=1');
                }
            }
        });
    }
    
    // Fonction pour gérer le bloc onglets
    function initBlockTabs() {
        $('.blocktabs').each(function() {
            let block = $(this);
            block.find('.tabs-content').css('min-height', $(this).find('.tabs-content').children('.tab:first-child').height() + 'px');
            
            block.find('.blocktabs-tabs .tabs button').click(function() {
                if(!$(this).hasClass('current')) {
                    let tabId = $(this).attr('id').split('tab-');
                    block.find('.tabs').children('.current').attr('aria-selected', false);
                    block.find('.tabs').children('.current').removeClass('current');
                    $(this).addClass('current');
                    $(this).attr('aria-selected', true);
                    block.find('.tabs-content').children('.current').attr('aria-hidden', true);
                    block.find('.tabs-content').children('.current').removeClass('current');
                    setTimeout(function () {
                        block.find('#tab-content-' + tabId[1]).addClass('current');
                        block.find('#tab-content-' + tabId[1]).attr('aria-hidden', false);
                        block.find('.tabs-content').css('min-height', block.find('#tab-content-' + tabId[1]).innerHeight() + 'px');
                    }, 300);
                }
            });
            
            $(window).resize(function() {
                block.find('.tabs-content').css('min-height', block.find('.tabs-content').children('.tab.current').innerHeight() + 'px');
            });
        });
    }
    
    // Fonction pour gérer les slider
    function initSwiperSlider() {
        if($('.swiper').length !== 0) {
            document.querySelectorAll(".swiper:not(.noMargin)").forEach(function (s) {
                let next = s.querySelector(".button-next");
                let prev = s.querySelector(".button-prev");
                
                let swiper = new Swiper(s, {
                    navigation: {
                        nextEl: next,
                        prevEl: prev
                    },
                    spaceBetween: 20,
                    slidesPerView: 'auto',
                    breakpoints: {
                        1000: {
                            spaceBetween: 30
                        }
                    }
                });
            });
            
            document.querySelectorAll(".swiper.noMargin").forEach(function (s) {
                let next = s.querySelector(".button-next");
                let prev = s.querySelector(".button-prev");
                let bullets = s.querySelector(".sliderbullets");
                
                let swiperNomargin = new Swiper(s, {
                    pagination: {
                        el: bullets,
                        type: 'bullets',
                        clickable: true
                    },
                    navigation: {
                        nextEl: next,
                        prevEl: prev
                    },
                    spaceBetween: 0,
                    slidesPerView: 'auto'
                });
            });
        }
    }

    // Fonction pour gérer la FAQ
    function initFaqBlock() {
        $('.faq .question').click(function() {
            if($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).parent().find('.answer').slideUp(300);
            }else {
                $(this).addClass('open');
                $(this).parent().find('.answer').slideDown(300);
            }
        });
    }
    
    // Fonction pour gérer le formulaire de qualification
    function initBlockQualif() {
        $('.blockqualif').each(function () {
            let block = $(this);
            // Type de travaux
            $(this).find('.form-row:first-child .type-chck').on('change', function() {
                block.find('.blockqualif-recap .type ul').empty();
                if($(this).val() !== '') {
                    block.find('.blockqualif-recap .type ul').append('<li>' + $(this).val() + '</li>');
                    block.find('.blockqualif-recap .type').slideDown(200);
                }else {
                    block.find('.blockqualif-recap .type').slideUp(200);
                }
                if($(this).val() === 'Rénovation') {
                    block.find('#sel-regle').slideUp(300);
                    $('#reglementation').val('').change();
                }else {
                    block.find('#sel-regle').slideDown(300);
                }
            });
            
            // Réglementation
            $(this).find('#reglementation').on('change', function() {
                block.find('.blockqualif-recap .reglem ul').empty();
                if($(this).val() !== '') {
                    block.find('.blockqualif-recap .reglem ul').append('<li>' + $(this).val() + '</li>');
                    block.find('.blockqualif-recap .reglem').slideDown(200);
                }else {
                    block.find('.blockqualif-recap .reglem').slideUp(200);
                }
            });
            
            // Activité
            $(this).find('#activity').on('change', function() {
                block.find('.blockqualif-recap .activity ul').empty();
                if($(this).val() !== '') {
                    block.find('.blockqualif-recap .activity ul').append('<li>' + $(this).val() + '</li>');
                    block.find('.blockqualif-recap .activity').slideDown(200);
                }else {
                    block.find('.blockqualif-recap .activity').slideUp(200);
                }
            });
            
            // Région
            $(this).find('#region').on('change', function() {
                block.find('.blockqualif-recap .region ul').empty();
                if($(this).val() !== '') {
                    block.find('.blockqualif-recap .region ul').append('<li>' + $(this).find('option:selected').text() + '</li>');
                    block.find('.blockqualif-recap .region').slideDown(200);
                }else {
                    block.find('.blockqualif-recap .region').slideUp(200);
                }
            });
            
            // Interêts
            $(this).find('#interest input').on('change', function() {
                if(block.find('#interest input:checked').length === 2) {
                    block.find('#interest input:not(:checked)').attr('disabled', true);
                }else {
                    block.find('#interest input').attr('disabled', false);
                }
                let interestvalue = [];
                block.find('#interest input:checked').each(function() {
                    interestvalue.push($(this).val());
                });
                block.find('.blockqualif-recap .interest ul').empty();
                interestvalue.forEach(function(value) {
                    block.find('.blockqualif-recap .interest ul').append('<li>' + value + '</li>');
                });
                if(interestvalue.length === 0) {
                    block.find('.blockqualif-recap .interest').slideUp(200);
                }else {
                    block.find('.blockqualif-recap .interest').slideDown(200);
                }
            });
            
            // Urgence
            $(this).find('input[name="emergency"]').on('change', function() {
                block.find('.blockqualif-recap .emergency ul').empty();
                block.find('.blockqualif-recap .emergency ul').append('<li>' + $(this).val() + '</li>');
                block.find('.blockqualif-recap .emergency').slideDown(200);
            });
            
            // Gestion bloc récapitulatif
            block.find('.blockqualif-recap .btn-more').click(function() {
                if($(this).hasClass('open')) {
                    $(this).removeClass('open');
                    block.find('.blockqualif-recap .allinfos').slideUp(200);
                }else {
                    $(this).addClass('open');
                    block.find('.blockqualif-recap .allinfos').slideDown(200);
                }
            });
            
            // Recap sticky
            $(window).scroll(function() {
                if($(this).scrollTop() >= block.find('.blockqualif-recap').offset().top) {
                    block.find('.blockqualif-recap .blockfixed').addClass('sticky');
                    if($(this).scrollTop() >= (block.find('.blockqualif-recap').offset().top + block.find('.blockqualif-form').innerHeight()) - block.find('.blockfixed').innerHeight()) {
                        block.find('.blockqualif-recap .blockfixed').addClass('toBottom');
                    }else {
                        block.find('.blockqualif-recap .blockfixed').removeClass('toBottom');
                    }
                }else {
                    block.find('.blockqualif-recap .blockfixed').removeClass('sticky');
                }
            });
            
            // Afficher le bouton quand on a tout rempli
            block.find('.blockqualif-form input, .blockqualif-form select').on('change', function() {
                let nbError = 0;
                if(block.find('input[name="type_trav"]:checked').length === 0) nbError++;
                if(block.find('input[name="type_trav"]:checked').val() !== 'Rénovation' && block.find('#reglementation').val() === '') nbError++;
                if(block.find('#activity').val() === '') nbError++;
                if(block.find('#region').val() === '') nbError++;
                if(block.find('#interest input:checked').length === 0) nbError++;
                if(block.find('input[name="emergency"]:checked').length === 0) nbError++;
                if(nbError === 0) {
                    block.find('.blockqualif-recap .btn-main').addClass('show');
                }else {
                    block.find('.blockqualif-recap .btn-main').removeClass('show');
                }
            });
        });
    }
    
    // Fonction pour gérer les filtres du bloc carrefour missions
    function initBlockMissions() {
        // Afficher/cacher les filtres en mobile
        $('.blockmissionspush-filters .filters-title').click(function() {
            if($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).next().slideUp(200);
            }else {
                $(this).addClass('open');
                $(this).next().slideDown(200);
            }
        });
        // Changer les filtres
        $('.blockmissionspush-filters input').change(function() {
            $('.blockmissionspush-filters input[name="paged"]').val('1');
            $('.blockmissionspush-filters .currentfilters .tags').html('');
            $('.blockmissionspush-filters input:checked').each(function() {
                $('.blockmissionspush-filters .currentfilters .tags').append('<li class="' + $(this).val() + '"><button type="button" class="tag">' + $('.blockmissionspush-filters input[value="' + $(this).val() + '"]').parent().find('span').html() + '</button></li>');
            });
            
            // Supprimer un filtre
            $('.blockmissionspush-filters .tag').click(function() {
                $('.blockmissionspush-filters input[name="paged"]').val('1');
                $('.blockmissionspush-filters input[value="' + $(this).parent().attr('class') + '"]').prop('checked', false);
                $(this).parent().remove();
                loadMissions();
            });
            loadMissions();
        });
        // Changer de page
        $('.blockmissionspush .pagination .page-numbers').click(function(e) {
            e.preventDefault();
            let pageNum = $(this).text().split('Page ')[1];
            $('.blockmissionspush-filters input[name="paged"]').val(pageNum);
            loadMissions();
        });
        
        function loadMissions() {
            $.ajax({
                type: "POST",
                url: $('.blockmissionspush-filters').attr('action'),
                data: $('.blockmissionspush-filters').serialize(), // serializes the form's elements.
                beforeSend: function () {
                    let offset = $('#missions').offset().top - 100;
                    $('html, body').animate({scrollTop: offset}, 500);
                    $('.blockmissionspush-content').addClass('load');
                },
                success: function (data, goTop) {
                    let $projects = $(data).find('.blockmissionspush-content').html();
                    $('.blockmissionspush-content').html($projects);
                    $('.blockmissionspush-content').removeClass('load');
                    $('.blockmissionspush .pagination .page-numbers').click(function(e) {
                        e.preventDefault();
                        let pageNum = $(this).text().split('Page ')[1];
                        $('.blockmissionspush-filters input[name="paged"]').val(pageNum);
                        loadMissions();
                    });
                },
                error: function (xhr, textStatus) {
                    console.log('error for loading page');
                    $('.blockmissionspush-content').removeClass('load');
                }
            });
        }
    }
    
    // Fonction pour afficher les infos du bloc régions
    function initBlockRegions() {
        $('.blockregion-form select').on('change', function() {
            let bloc = $(this).parent().parent();
            $.ajax({
                type: "GET",
                url: $(this).parent().attr('action'),
                data: $(this).parent().serialize(), // serializes the form's elements.
                beforeSend: function () {
                    bloc.find('.blockregion-infos').addClass('load');
                },
                success: function (data, goTop) {
                    bloc.find('.blockregion-infos').removeClass('load');
                    let $regioninfo = $(data).find('.blockregion-infos').html();
                    bloc.find('.blockregion-infos').html($regioninfo);
                },
                error: function (xhr, textStatus) {
                    console.log('error for loading page');
                    bloc.find('.blockregion-infos').removeClass('load');
                }
            });
        });
    }

    // Fonction pour gérer les filtres sur le bloc de certifications
    function initBlockCertifs() {
        $('.blockcertifs-filter input').change(function() {
            $.ajax({
                type: "GET",
                url: $('.blockcertifs-filter').attr('action'),
                data: $('.blockcertifs-filter').serialize(), // serializes the form's elements.
                beforeSend: function () {
                    $('.blockcertifs-filter').parent().addClass('load');
                },
                success: function (data, goTop) {
                    let $certifs = $(data).find('.blockcertifs-content').html();
                    $('.blockcertifs-content').html($certifs);
                    $('.blockcertifs-filter').parent().removeClass('load');
                    const swiper = new Swiper('.blockcertifs .swiper', {
                        navigation: {
                            nextEl: '.button-next',
                            prevEl: '.button-prev',
                        },
                        spaceBetween: 20,
                        slidesPerView: 'auto',
                        breakpoints: {
                            1000: {
                                spaceBetween: 30
                            }
                        }
                    });
                },
                error: function (xhr, textStatus) {
                    console.log('error for loading page');
                    $('.blockcertifs-filter').parent().removeClass('load');
                }
            });
        });
    }
    
    // Fonction pour gérer la lecture des podcasts
    function initPodcasts() {
        if($('.podcasts-list').length !== 0) {
            $('.podcasts-elem').each(function() {
                let audio = $(this).find('audio');
                let audioDuration = audio[0].duration;
                $(this).find('.timer').html(Math.floor(audioDuration / 60) + ' min');
            });
        }
        
        if($('.podcastsingle-media').length !== 0) {
            let audio = $('.podcastsingle-media').find('audio');
            let timeline = $('.podcastsingle-media').find('.piste');
            let audioDuration = audio[0].duration;
            
            $('.podcastsingle-media .timer').html(Math.floor(audioDuration / 60) + ' min');
            
            $('.podcastsingle-media .btnlisten').click(function() {
                if(audio[0].paused) {
                    $(this).removeClass('play');
                    $(this).addClass('pause');
                    audio.trigger("play");
                }else {
                    $(this).removeClass('pause');
                    $(this).addClass('play');
                    audio.trigger("pause");
                }
            });
            
            // Au clic sur la timeline on va au temps correspondant
            timeline.on('click', function(e) {
                let timelineWidth = $(this).innerWidth();
                const timeToSeek = e.offsetX / parseInt(timelineWidth) * audioDuration;
                audio[0].currentTime = timeToSeek;
                $('.piste-current').html(convertTimer(timeToSeek));
                $('.piste-timer').css('width', timeToSeek / audioDuration * 100 + "%");
            });
            
            // On met à jour l'avancement du timer
            setInterval(() => {
                const progressBar =  $('.piste-timer');
                let audioCurTime = audio[0].currentTime;
                // On récupère la durée totale de l'audio
                if(audioDuration !== 'NaN') $('.piste-current').html(convertTimer(audioDuration));
                progressBar.css('width', audioCurTime / audioDuration * 100 + "%");
                $('.piste-current').html(convertTimer(audioCurTime));
                
                // Si on arrive à la fin on met en pause le lecteur
                if(audioCurTime === audioDuration) {
                    $('.btnlisten').addClass('play');
                    $('.btnlisten').removeClass('pause');
                }
            }, 500);
        }
    }
    
    // Conversion du temps en string
    function convertTimer(d) {
        var convertTimer = '';
        var d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);
        
        if(h !== 0) convertTimer = (h < 10) ? h + ':' : h + ':';
        convertTimer = (m < 10) ? convertTimer + m + ':' : convertTimer + m + ':';
        convertTimer = (s < 10) ? convertTimer + '0' + s : convertTimer + s;
        return convertTimer;
    }
    
    // Fonction pour activer la lightbox des ouvrages
    function initBookGallery() {
        if($('.singlebook-cover .gallery').length !== 0) {
            let lightbox = new SimpleLightbox({
                elements: document.querySelectorAll('.singlebook-cover .gallery a'),
                closeBtnCaption: 'Fermer',
                nextBtnCaption: 'Suivant',
                prevBtnCaption: 'Précédent',
                loadingCaption: 'Chargement...',
            });
        }
    }